// WhatsApp without any server: the message opens in the user's own WhatsApp (wa.me link),
// with the client's number and the text already filled in. Same rules as backend/whatsapp_links.py.

const COUNTRY_CODE = '39';

/** '333 123 4567' → '393331234567'; '' when it cannot be a phone number. */
export function normalizePhone(raw, countryCode = COUNTRY_CODE) {
  const value = String(raw || '').trim();
  if (!value) return '';
  const international = value.startsWith('+') || value.startsWith('00');
  let digits = value.replace(/\D/g, '');
  if (value.startsWith('00')) digits = digits.slice(2);
  if (!international) {
    const hasPrefix = digits.startsWith(countryCode) && digits.length >= 11;
    if (!hasPrefix && /^[30]/.test(digits)) digits = countryCode + digits;
  }
  return digits.length >= 8 && digits.length <= 15 ? digits : '';
}

export function waLink(phone, text) {
  const number = normalizePhone(phone);
  const base = `https://wa.me/${number}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

const STATUS_LABELS = {
  draft: 'bozza', sent: 'inviato', accepted: 'accettato', rejected: 'rifiutato', won: 'vinto', lost: 'perso',
};

/** '€ 1.464,00' (Intl's it-IT leaves 4-digit amounts ungrouped, the quote email does not). */
export function formatEuro(n) {
  const [int, dec] = Math.abs(Number(n) || 0).toFixed(2).split('.');
  return `${Number(n) < 0 ? '-' : ''}€ ${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`;
}

/** Fill a WhatsApp template ({nome_cliente}, {numero_preventivo}, {totale}, ...). */
export function fillTemplate(body, { quote, client, companyName } = {}) {
  const values = {
    nome_cliente: quote?.client_name || client?.name || 'Cliente',
    numero_preventivo: quote?.quote_number || '-',
    totale: quote ? formatEuro(quote.total ?? quote.total_amount) : '-',
    num_prodotti: String(quote?.items?.length || 0),
    stato: quote ? (STATUS_LABELS[quote.status] || quote.status || '-') : '-',
    nome_azienda: companyName || '',
  };
  return String(body || '').replace(/\{(\w+)\}/g, (m, key) => (key in values ? values[key] : m));
}

/** Templates that only make sense with a quote. */
export const needsQuote = (body) => /\{(numero_preventivo|totale|num_prodotti|stato)\}/.test(body || '');
